import {Alert, Typography} from "@material-tailwind/react";
import React from "react";

export function PersonServiceHeaderAlert() {
  return (
    <Alert className="mt-8 w-full px-2" variant="gradient">
      <Typography variant="h5" className="mb-4">
        کاربر گرامی؛
      </Typography>
      <Typography variant="body" className="px-4">
        <li>
          از طریق دکمه مشاهده/بررسی مدارک می توانید مدارک و مستندات خود را برای مشاور
          ارسال نمائید.
          هزینه‌های جانبی و دولتی خدمت، در قیمت ها لحاظ نشده است و باید توسط خودتان پرداخت
          گردد.
        </li>
        <li>
          پس از پرداخت، فرآیند خدمت آغاز خواهد شد و مشاور موظف است پس از پایان هر مرحله
          از خدمت، گزارش پیشرفت خدمت را به شما اطلاع رسانی نماید.
        </li>
        <li>
          بدیهی است در صورت عدم تامین مدارک و مستندات لازم از سوی کاربر، هرگونه تاخیر و
          تبعات بر عهده کاربر خواهد بود.
        </li>
      </Typography>
    </Alert>
  )
}
